import React from 'react';

const Home: React.FunctionComponent = () => {
  return <div>Welcome to BrickWall!</div>;
};

export default Home;
